export default {
  title: 'SMS Marketing Channels',

  // Form related
  form: {
    phoneCode: 'Phone Code',
    phoneCodePlaceholder: 'Please enter phone code',
    channelName: 'Channel Name',
    channelNamePlaceholder: 'Please enter channel name',
    country: 'Country',
    countryPlaceholder: 'Please select country',
    status: 'Status',
    statusPlaceholder: 'Please select status',
    currency: 'Currency',
    currencyPlaceholder: 'Please select currency',
    cost: 'Cost',
    costPlaceholder: 'Please enter cost',
    remark: 'Remark',
    remarkPlaceholder: 'Please enter remark'
  },

  // Table related
  table: {
    channelName: 'Channel Name',
    country: 'Country',
    cost: 'Cost',
    currency: 'Currency',
    status: 'Status',
    remark: 'Remark',
    actions: 'Actions'
  },

  // Status related
  status: {
    enabled: 'Enabled',
    disabled: 'Disabled'
  },

  // Modal related
  modal: {
    editTitle: 'Edit SMS Channel'
  },

  // Validation related
  validation: {
    channelNameRequired: 'Please enter channel name',
    countryRequired: 'Please select country',
    phoneCodeRequired: 'Please enter phone code',
    currencyRequired: 'Please select currency',
    costRequired: 'Please enter cost',
    costMin: 'Cost cannot be less than 0',
    statusRequired: 'Please select status'
  },

  // Message related
  message: {
    queryFailed: 'Query failed',
    updateSuccess: 'Update successful',
    updateFailed: 'Update failed',
    statusUpdateSuccess: 'Status update successful',
    statusUpdateFailed: 'Status update failed'
  },

  // Confirm related
  confirm: {
    toggleStatus: 'Are you sure to toggle the status of this channel?'
  },

  // Pagination related
  pagination: {
    total: 'Total {{total}} records'
  }
};
